import { computed, Ref, ref } from 'vue'

export function usePagination(totalItems: Ref<number>, itemsPerPage = 10) {
  const currentPage = ref(1)

  const totalPages = computed(() => {
    const total = Math.ceil(totalItems.value / itemsPerPage)
    return total > 0 ? total : 1
  })

  const visiblePages = computed(() => {
    const pages: (number | string)[] = []
    const total = totalPages.value
    const current = currentPage.value

    if (total <= 6) {
      for (let i = 1; i <= total; i++) {
        pages.push(i)
      }
    } else {
      if (current <= 5) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(total)
      } else if (current >= total - 4) {
        pages.push(1)
        pages.push('...')
        for (let i = total - 4; i <= total; i++) {
          pages.push(i)
        }
      } else {
        pages.push(1)
        pages.push('...')
        for (let i = current - 1; i <= current + 1; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(total)
      }
    }

    return pages
  })

  const goToPage = (page: number | string) => {
    if (typeof page === 'number') {
      currentPage.value = page
    }
  }

  const resetPage = () => {
    currentPage.value = 1
  }

  return {
    currentPage,
    totalPages,
    visiblePages,
    itemsPerPage,
    goToPage,
    resetPage,
  }
}
